import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '@shared';
import { ProductService } from '../../services/productservice';
import { HomeRoutingModule } from './home-routing.module';
import { ShellModule } from '../shell/shell.module';
import { HomeComponent } from './home.component';
import { LegacyHomeComponent } from '../legacy/legacy-home.component';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
// import { LatestvideoComponent } from '../latestvideo/latestvideo.component';
// import { CategoriesComponent } from '../categories/categories.component';
// import { InstagramComponent } from '../instagram/instagram.component';
import { GalleriaModule } from 'primeng/galleria';
import { InstaService } from 'src/services/insta.service';
import { SearchComponent } from '../search/search.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { ListboxModule } from 'primeng/listbox';
import { FormsModule } from '@angular/forms';
import { IslandsOverviewComponent } from '../islands-overview/islands-overview.component';
import { CategorySliderComponent } from '../category-slider/category-slider.component';
import { ExploreIslandComponent } from '../explore-island/explore-island.component';
import { RatingModule } from 'primeng/rating';
import { CardModule } from 'primeng/card';
import { SliderModule } from 'primeng/slider';
import { DataViewModule } from 'primeng/dataview';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { GMapModule } from 'primeng/gmap';
import { IslandDetailsComponent } from '../island-details/island-details.component';
import { IslandsComponent } from '../islands/islands.component';
import { AboutUsComponent } from '../about-us/about-us.component';
import { AboutUsDetailComponent } from '../about-us/about-us-detail/about-us-detail.component';
import { ContactComponent } from '../contact/contact.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { CaptchaModule } from 'primeng/captcha';
import { FrequentlyquestionsComponent } from '../frequentlyquestions/frequentlyquestions.component';
import { TermsofuseComponent } from '../termsofuse/termsofuse.component';
import { PrivacypolicyComponent } from '../privacypolicy/privacypolicy.component';
import { OpenweathermapComponent } from '../openweathermap/openweathermap.component';
import { MediaCenterdetailsComponent } from '../media-centerdetails/media-centerdetails.component';
import { GooglemapsComponent } from '../googlemaps/googlemaps.component';
import { ExploreSeychellesComponent } from '../explore-seychelles/explore-seychelles.component';
import { WishlistComponent } from '../wishlist/wishlist.component';
import { HighLightsDetailsComponent } from '../highLights/high-lights-details/high-lights-details.component';
import { HighLightsAllComponent } from '../highLights/high-lights-all/high-lights-all.component';
// import { HighlightsComponent } from '../highLights/highlights/highlights.component';
import { SpecialIntrestComponent } from '../special-intrest/special-intrest.component';
import { CreoleComponent } from '../creole/creole.component';
import { DownloadsComponent } from '../downloads/downloads.component';
import { TravelAdvisoryComponent } from '../travel-advisory/travel-advisory.component';
import { TravelInfoComponent } from '../travel-info/travel-info.component';
import { BreadcrumbModule } from '../breadcrumb/breadcrumb.module';
import { IslandGroupsComponent } from '../island-groups/island-groups.component';
import { AboutUsItemsComponent } from '../about-us/about-us-items/about-us-items.component';
import { TooltipModule } from 'primeng/tooltip';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { PanelModule } from 'primeng/panel';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SharePopupModule } from '../share-popup/share-popup.module';
import { TokencheckComponent } from '../tokencheck/tokencheck.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { UserActivationComponent } from '../user-activation/user-activation.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { BreadcrumbRowModule } from '../breadcrumb-row/breadcrumb-row.module';
// NewHomeHeaderComponent moved to ShellModule
import { BannerComponent } from '../banner/banner.component';
import { BannerCategorySliderComponent } from '../banner-category-slider/banner-category-slider.component';
// MenuComponent moved to ShellModule
import { SpecialInterestSectionComponent } from '../special-interest-section/special-interest-section.component';
// NewFooterComponent moved to ShellModule
// LanguageSelectorComponent moved to ShellModule
import { WhatsHappeningComponent } from '../whats-happening/whats-happening.component';
import { WheretostayComponent } from '../where-to-stay/where-to-stay.component';
import { BlogComponent } from '../blog/blog.component';
import { CreoleSectionComponent } from '../creole-section/creole-section.component';
import { DownloadSectionComponent } from '../download-section/download-section.component';
import { CrowdiffComponent } from '../crowdiff/crowdiff.component';
import { AlertPopupComponent } from '../alert-popup/alert-popup.component';
import { FlipbookComponent } from '../flipbook/flipbook.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    // BrowserModule, // Should only be in AppModule
    // BrowserAnimationsModule, // Should only be in AppModule
    TranslateModule,
    SharedModule,
    ShellModule,
    HomeRoutingModule,
    CarouselModule,
    ToastModule,
    ButtonModule,
    TabViewModule,
    GalleriaModule,
    CheckboxModule,
    AutoCompleteModule,
    TableModule,
    AccordionModule,
    ListboxModule,
    PanelModule,
    FormsModule,
    RatingModule,
    RadioButtonModule,
    CardModule,
    SliderModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    InputTextareaModule,
    InputNumberModule,
    OverlayPanelModule,
    CaptchaModule,
    GMapModule,
    DataViewModule,
    TooltipModule,
    SelectButtonModule,
    ToggleButtonModule,
    DropdownModule,
    DialogModule,
    BreadcrumbRowModule,
    BreadcrumbModule,
    SharePopupModule,
  ],
  declarations: [
    HomeComponent,
    LegacyHomeComponent,

    // LatestvideoComponent,
    // CategoriesComponent,
    // InstagramComponent,
    SearchComponent,
    IslandsOverviewComponent,
    CategorySliderComponent,
    ExploreIslandComponent,
    IslandDetailsComponent,
    IslandsComponent,
    AboutUsComponent,
    AboutUsDetailComponent,
    IslandGroupsComponent,
    ContactComponent,
    FrequentlyquestionsComponent,
    TermsofuseComponent,
    PrivacypolicyComponent,
    MediaCenterdetailsComponent,
    GooglemapsComponent,
    ExploreSeychellesComponent,
    WishlistComponent,
    HighLightsDetailsComponent,
    HighLightsAllComponent,
    // HighlightsComponent,
    SpecialIntrestComponent,
    CreoleComponent,
    TravelInfoComponent,
    TravelAdvisoryComponent,
    AboutUsItemsComponent,
    OpenweathermapComponent,
    TokencheckComponent,
    ChangePasswordComponent,
    UserActivationComponent,
    DownloadsComponent,
    // NewHomeHeaderComponent, // moved to ShellModule
    BannerComponent,
    BannerCategorySliderComponent,
    // MenuComponent, // moved to ShellModule
    SpecialInterestSectionComponent,
    // NewFooterComponent, // moved to ShellModule
    // LanguageSelectorComponent, // moved to ShellModule
    WhatsHappeningComponent,
    WheretostayComponent,
    BlogComponent,
    CreoleSectionComponent,
    DownloadSectionComponent,
    CrowdiffComponent,
    AlertPopupComponent,
    // YouTubeComponent,
    FlipbookComponent,
  ],

  providers: [ProductService, InstaService],
})
export class HomeModule {}
